import React, { useRef, useState, useEffect } from "react";
import { SendBtn } from "../../utils/icons";
import { useDispatch, useSelector } from "react-redux";
import { setMessageReducer } from "../../slices/userSlice";
import { PaperClipOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import { uploadDocFun, uploadFilesToS3 } from "../../utils/utils";
import toastMessage from "../../utils/toastMessage";
import { generateRandomNumber } from "../../utils/utils";
import ImageModal from "./ImageModal";

const MessagesAndInput = ({ type = "private", children }) => {
  const dispatch = useDispatch();
  const inpRef = useRef();
  const selectedUserOrChannel =
    useSelector((state) => state.user.selectedUserOrChannel) || {};
  const userAttributes =
    useSelector((state) => state.user.userAttributes) || {};
  const websocket = useSelector((state) => state.socket.websocket);
  const [attachments, setAttachments] = useState([]);
  const [previewImage, setPreviewImage] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [oldImagePreview, setOldImagePreview] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStartIndex, setModalStartIndex] = useState(0);

  // Cleanup blob URLs when component unmounts or attachments change
  useEffect(() => {
    return () => {
      previewImage.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [previewImage]);

  // const handleFileChange = ({ fileList }) => {
  //   setAttachments(fileList);

  //   const previewUrls = fileList.map(file => URL.createObjectURL(file.originFileObj));
  //   setPreviewImage(previewUrls);
  // };

  const handleFileChange = ({ fileList }) => {
    setAttachments(fileList);

    const newPreviewImage = fileList.map((file) => {
      const extension = file.name.split(".").pop().toLowerCase();
      if (
        [
          "jpg",
          "jpeg",
          "png",
          "gif",
          "tiff",
          "bmp",
          "svg",
          "webp",
          "ico",
          "heif",
          "heic",
        ].includes(extension)
      ) {
        return { type: "image", url: URL.createObjectURL(file.originFileObj) };
      } else if (extension === "pdf") {
        return { type: "pdf", name: file.name };
      } else if (["mp3", "wav", "ogg", "m4a"].includes(extension)) {
        return { type: "audio", url: URL.createObjectURL(file.originFileObj) };
      } else if (["mp4", "webm", "ogg", "mov"].includes(extension)) {
        return { type: "video", url: URL.createObjectURL(file.originFileObj) };
      }
      return { type: "other", name: file.name };
    });

    setPreviewImage(newPreviewImage);
  };

  const props = {
    name: "attachments",
    headers: {
      authorization: "authorization-text",
    },
    accept: "*",
    multiple: true,
    showUploadList: false,
    beforeUpload: () => false,
    onChange: handleFileChange,
    fileList: attachments,
  };

  const handleRemoveAttachment = (index) => {
    setAttachments((prev) => {
      const filtered = prev.filter((val, i) => i !== index);
      return filtered;
    });
    setPreviewImage((prev) => {
      const filtered = prev.filter((val, i) => i !== index);
      return filtered;
    });

    URL.revokeObjectURL(previewImage[index]);
  };

  const handleMessageSend = async (e) => {
    e.preventDefault();
    const msg = inpRef.current.value || "";
    if (msg.length === 0 && attachments.length === 0) return;

    setIsUploading(true);
    const body = {};
    let attachmentsFilesName = [];
    let senderId = userAttributes?.sub.includes("User#") ? userAttributes?.sub : `User#${userAttributes?.sub}`;
    console.log(senderId, "======snederIdddddd:nn", selectedUserOrChannel);
    if (attachments.length > 0) {
      try {
        attachmentsFilesName = await uploadFilesToS3(attachments);
        console.log(attachmentsFilesName, "attachmentsFilesName:mess:attach");
      } catch (error) {
        console.log(error, "error:attachmentsFilesName:mess:attach");
        return toastMessage(error.message, "error");
      }
    }

    if (selectedUserOrChannel?.type === 'user') {
      const ids = [senderId, selectedUserOrChannel.PK].sort().join("_");
      body.PK = `Private#${ids}`;
      body.SK = `Msg#${generateRandomNumber()}`;
      body.Content = msg;
      body.Attachments = attachmentsFilesName;
      body.Sender = senderId;
      body.Receiver = selectedUserOrChannel.PK;
      body.IsReceiverRead = false;
      body.MsgType = "text";
      body.CreatedAt = new Date();
      body.RequestType = "private-message";
    } else if (selectedUserOrChannel?.type === "channel") {
      body.PK = selectedUserOrChannel?.SK;
      body.SK = `Msg#${generateRandomNumber()}`;
      body.Content = msg;
      body.Attachments = attachmentsFilesName;
      body.Sender = senderId;
      body.MsgType = "text";
      body.CreatedAt = new Date();
      body.RequestType = "channel-message";
    }

    console.log(body, "===bodyyyyyyyyyyyyy:abcd");
    
    dispatch(setMessageReducer({ newMsg: body, isSend: true }));

    if (websocket && websocket.readyState === WebSocket.OPEN) {
      websocket.send(JSON.stringify({ action: "sendmessage", ...body }));
    } else {
      console.error("WebSocket is not connected.");
    }

    inpRef.current.value = "";
    setAttachments([]);
    setPreviewImage([]);
    setIsUploading(false);
  };

  const handleImageClick = (index, images) => {
    setIsModalOpen(true);
    setModalStartIndex(index);
    setOldImagePreview(images);
  };

  return (
    <div className="w-full absolute bottom-2 left-1">
      <div className="flex flex-col">
        {previewImage.length > 0 && (
          <div className="w-full flex flex-row gap-2 items-center h-[75px] overflow-y-hidden bg-gray-50 px-2 rounded-lg">
            {previewImage.map((file, index) => {
              switch (file.type) {
                case "image":
                  return (
                    <div key={index} className="bg-gray-200 relative">
                      <p
                        onClick={() => handleRemoveAttachment(index)}
                        className="bg-red-500 text-white rounded-full w-4 h-4 pb-1 text-[14px] text-center absolute top-0 right-0 z-[999] cursor-pointer"
                      >
                        X
                      </p>
                      <img
                        src={file.url}
                        alt="Preview"
                        style={{
                          width: "70px",
                          height: "70px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  );
                case "audio":
                case "video":
                  return (
                    <div key={index} className="bg-gray-200 relative">
                      <p
                        onClick={() => handleRemoveAttachment(index)}
                        className="bg-red-500 text-white rounded-full w-4 h-4 pb-1 text-[14px] text-center absolute top-0 right-0 z-[999] cursor-pointer"
                      >
                        X
                      </p>
                      {file.type === "audio" ? (
                        <audio
                          controls
                          src={file.url}
                          style={{ width: "140px", height: "70px" }}
                        />
                      ) : (
                        <video
                          controls
                          src={file.url}
                          style={{ width: "70px", height: "70px" }}
                        />
                      )}
                    </div>
                  );
                case "pdf":
                  return (
                    <div
                      key={index}
                      className="bg-gray-200 relative flex items-center justify-center"
                      style={{ width: "70px", height: "70px" }}
                    >
                      <p
                        onClick={() => handleRemoveAttachment(index)}
                        className="bg-red-500 text-white rounded-full w-4 h-4 pb-1 text-[14px] text-center absolute top-0 right-0 z-[999] cursor-pointer"
                      >
                        X
                      </p>
                      <span>{file.name}</span>
                    </div>
                  );
                default:
                  return null;
              }
            })}
          </div>
        )}

        <form className={`w-full`} onSubmit={handleMessageSend}>
          <div className="flex items-center bg-[#eeeeee] px-3 py-1 rounded-3xl">
            <Upload {...props} className="w-6">
              <PaperClipOutlined className="cursor-pointer hover:text-gray-500 w-6" />
            </Upload>
            <textarea
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleMessageSend(e);
                }
              }}
              style={{ height: "25px" }}
              ref={inpRef}
              placeholder="Start typing..."
              className="w-full bg-transparent border-none outline-none resize-none"
            />
            <button disabled={isUploading} type="submit">
              <SendBtn />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MessagesAndInput;